import { create } from 'zustand';

const useActiveAccordianStore = create((set) => ({
  activeAccordian: [],
  setActiveAccordian: (newId) => set((state) => ({ ...state, activeAccordian: newId })),
}));

export default useActiveAccordianStore;

